import {http} from '@/axios'
import $router from '@/router'
import Vue from 'vue'
import makeNotificationSound from '@/helpers/makeNotificationSound'
// import {CancelToken} from 'axios'

let cancelLoadNew;

function getInitState(state) {
  return {
    messages: [],
    hasNewFromServer: state ? state.hasNewFromServer : false,
    pending: false,
    pendingLoadMore: false,
    pendingLoadNew: false,
    pendingSend: false,
    error: false,
  }
}

export default {
  namespaced: true,
  state: getInitState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState(state))
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },
    pushMessages(state, messages) {
      state.messages = state.messages.concat(messages)
    },
    unshiftMessages(state, messages) {
      state.messages = messages.concat(state.messages)
    },
    deleteMessage(state, index) {
      Vue.delete(state.messages, index)
    },
    setMessagePending(state, [index, value]) {
      Vue.set(state.messages[index], 'pending', value)
    }
  },
  actions: {
    stop({dispatch}) {
      if (cancelLoadNew) {
        cancelLoadNew()
        cancelLoadNew = null
      }

      dispatch('unSubscribeOnUpdate')
    },
    subscriberOnUpdate({rootState, commit, dispatch}) {
      this.dispatch('user/userPusher/createPusher')

      dispatch('unSubscribeOnUpdate')

      const channel = rootState.user.userPusher.channel
      channel.bind('update-interaction-files-tab', () => {
        makeNotificationSound()
        commit('setProperty', ['hasNewFromServer', true])
      })
    },
    unSubscribeOnUpdate({rootState}) {
      const channel = rootState.user.userPusher.channel
      if (!channel) return
      channel.unbind('update-interaction-files-tab')
    },
    load({commit}, id) {
      commit('setProperty', ['pending', true])

      return http.get(`/api/new-interaction/${id}/files-tab/get`).then(({data}) => {
        if (data.data === false) return

        commit('setProperty', ['messages', data.data.files])
        commit('setProperty', ['hasNewFromServer', data.data.has_new])
      }).finally(() => {
        commit('setProperty', ['pending', false])
      })
    },
    loadNewMessages({dispatch}) {
      const interactionId = $router.currentRoute.params.id
      return dispatch('load', interactionId)
      // commit('setProperty', ['pendingLoadNew', true])
      // const interactionId = $router.currentRoute.params.id
      //
      // if (cancelLoadNew) {
      //   cancelLoadNew()
      //   cancelLoadNew = null
      // }
      //
      // clearTimeout(state.timerLoadMew)
      //
      // return http.get('/api/new-interaction/chat', {
      //   params: {
      //     interaction_id: interactionId,
      //     chat_message_id: state.messages[0] ? state.messages[state.messages.length - 1].id : null,
      //     back: 0
      //   },
      //   cancelToken: new CancelToken(c => cancelLoadNew = c)
      // }).then(({data}) => {
      //   if (data.data === false) return
      //
      //   commit('pushMessages', data.data.chat_messages)
      //   commit('setProperty', ['interlocutor', data.data.interlocutor])
      //   commit('setProperty', ['me', data.data.me])
      // }).finally(() => {
      //   commit('setProperty', ['pendingLoadNew', false])
      // })
    },
    sendMessage({commit}, {files}) {
      commit('setProperty', ['pendingSend', true])

      const interactionId = $router.currentRoute.params.id
      const formData = new FormData()

      for (const file of files) {
        formData.append('files[]', file)
      }

      return http.post(`/api/new-interaction/${interactionId}/files-tab/upload`, formData)
          .then(async ({data}) => {
            const filesReceived = data.data.map(file => {
              return {
                viewed: 1,
                file
              }
            })

            commit('pushMessages', filesReceived)
            // await dispatch('loadNewMessages', data)
          })
          .finally(() => {
            commit('setProperty', ['pendingSend', false])
          })
    },

    deleteMessage({state, commit}, index) {
      const interactionId = $router.currentRoute.params.id
      const file = state.messages[index]

      commit('setMessagePending', [index, true])

      http.delete(`/api/new-interaction/${interactionId}/files-tab/remove/${file.file.id}`)
          .then(() => {
            commit('deleteMessage', index)
          })
          .catch(() => {
            commit('setMessagePending', [index, false])
          })
    },
    getViewedStatus({commit}) {
      const interactionId = $router.currentRoute.params.id
      http.get(`/api/new-interaction/${interactionId}/files-tab/get-status`)
          .then(({data}) => {
            commit('setProperty', ['hasNewFromServer', data.data.has_new])
          })
    },

    setViewed({state, commit}) {
      if (!state.hasNewFromServer) return

      const interactionId = $router.currentRoute.params.id
      http.get(`/api/new-interaction/${interactionId}/files-tab/set-viewed `).then(() => {
        commit('setProperty', ['hasNewFromServer', false])
      })
    }
  }
}
